export default {
  baseStyle: {
    // this is to change the colored portion of the spinner to only take up 25% of the circle
    // instead of 50%
    borderTopColor: 'gray.200',
  },
}
